import { api, resolvePagination } from './api';
import { getLastYearDate, getRequestDate } from 'utils/dateUtils';

const nextDay = () => {
    const currentDate = new Date();
    const n = new Date(currentDate);
    n.setDate(currentDate.getDate() + 1);
    return n;
};

/**
 * Get latest chats (conversation list)
 */
export const getChats = async ({ pageLimit, pageToken } = {}) =>
    api.get('/cheart/chats', {
        headers: resolvePagination(pageToken, pageLimit)
    });

/**
 * Get messages for a conversation
 */
export const getMessages = async ({
    chatter,
    qi = getLastYearDate(1),
    qf = nextDay(),
    onlyUnseen = false,
    pageLimit,
    pageToken
}) =>
    api.post(
        '/cheart/chat/messages',
        {
            chatter,
            qi: getRequestDate(qi),
            qf: getRequestDate(qf),
            only_unseen: onlyUnseen
        },
        {
            headers: resolvePagination(pageToken, pageLimit)
        }
    );

/**
 * Get every unseen message involving the current role.
 * Incoming messages are selected client-side because the API also returns
 * sent messages that have not yet been seen by their receiver.
 */
export const getUnseenMessages = async ({ pageLimit = 50, pageToken } = {}) =>
    api.post(
        '/cheart/chat/messages',
        { only_unseen: true },
        {
            headers: resolvePagination(pageToken, pageLimit)
        }
    );

/**
 * Fetch a specific message by UUID
 */
export const fetchMessage = async (uuid) =>
    api.post('/cheart/chat/messages/fetch', { uuid });

/**
 * Send a new message
 */
export const sendMessage = async ({ to, message }) =>
    api.post('/cheart/chat', {
        to,
        message,
        sent_at: new Date().toISOString()
    });

/**
 * Mark message as seen
 */
export const markMessageAsSeen = async (uuid) => {
    const payload = { uuid };
    return api.patch('/cheart/chat', payload);
};

/**
 * Get contacts list
 */
export const getContacts = async ({ pageLimit, pageToken } = {}) =>
    api.get('/cheart/chat/contacts', {
        headers: resolvePagination(pageToken, pageLimit)
    });

/**
 * Search contacts by query
 */
export const searchContacts = async ({ query, pageLimit, pageToken }) =>
    api.post(
        '/cheart/chat/contacts/search',
        { query },
        {
            headers: resolvePagination(pageToken, pageLimit)
        }
    );
